var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { clsx } from "../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { twMerge } from "../node_modules/.pnpm/tailwind-merge@3.3.0/node_modules/tailwind-merge/dist/bundle-mjs.js";
import { defineComponent, isRef } from "vue";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
__name(cn, "cn");
const SmartRenderer = defineComponent({
  name: "SmartRenderer",
  props: {
    children: null
  },
  render({ children }) {
    return isRef(children) ? children.value : children;
  }
});
function styleNumberValueWithUnit(width) {
  return typeof width == "number" || /^-?\d+(?:\.\d+)?$/.test(width) ? `${width}px` : width;
}
__name(styleNumberValueWithUnit, "styleNumberValueWithUnit");
function vnodeBindingVModel(props) {
  if (!props)
    return !1;
  const keys = Object.keys(props);
  return keys.includes("modelValue") && keys.includes("onUpdate:modelValue");
}
__name(vnodeBindingVModel, "vnodeBindingVModel");
function resolveVNode(v) {
  return typeof v == "function" ? v() : v;
}
__name(resolveVNode, "resolveVNode");
export {
  SmartRenderer,
  cn,
  resolveVNode,
  styleNumberValueWithUnit,
  vnodeBindingVModel
};
//# sourceMappingURL=utils.js.map
